var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickBooksIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12012_27056)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12012_27056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C17.6348 0 11.5303 2.52856 7.02944 7.02944C2.52856 11.5303 0 17.6348 0 24C0 30.3652 2.52856 36.4697 7.02944 40.9706C11.5303 45.4714 17.6348 48 24 48C30.3652 48 36.4697 45.4714 40.9706 40.9706C45.4714 36.4697 48 30.3652 48 24C48 17.6348 45.4714 11.5303 40.9706 7.02944C36.4697 2.52856 30.3652 0 24 0ZM25.284 8.268C27.194 8.268 28.744 9.818 28.744 11.734V29.866H31.944C33.4732 29.8261 34.9264 29.1905 35.9939 28.0948C37.0614 26.999 37.6588 25.5298 37.6588 24C37.6588 22.4702 37.0614 21.001 35.9939 19.9052C34.9264 18.8095 33.4732 18.1739 31.944 18.134H30.612V14.666H31.942C33.1667 14.6671 34.3792 14.9093 35.5103 15.379C36.6414 15.8486 37.6689 16.5364 38.5341 17.4032C39.3994 18.2699 40.0855 19.2986 40.5532 20.4305C41.0209 21.5624 41.2611 22.7753 41.26 24C41.2618 25.2248 41.0223 26.4379 40.555 27.57C40.0877 28.7021 39.4018 29.731 38.5366 30.5979C37.6714 31.4647 36.6438 32.1526 35.5126 32.6221C34.3814 33.0916 33.1688 33.3335 31.944 33.334H25.286L25.284 8.268ZM15.968 14.666H22.626V39.732C20.714 39.732 19.166 38.18 19.166 36.266V18.132H15.966C14.4287 18.1604 12.964 18.791 11.8869 19.8882C10.8098 20.9854 10.2063 22.4615 10.2063 23.999C10.2063 25.5365 10.8098 27.0126 11.8869 28.1098C12.964 29.207 14.4287 29.8376 15.966 29.866H17.298V33.332H15.968C14.7434 33.3315 13.5309 33.0896 12.3998 32.6203C11.2688 32.1509 10.2413 31.4632 9.37611 30.5966C8.51093 29.7299 7.82503 28.7013 7.35761 27.5694C6.8902 26.4375 6.65042 25.2246 6.652 24C6.65016 22.7752 6.88974 21.5621 7.35704 20.43C7.82434 19.2979 8.5102 18.269 9.3754 17.4021C10.2406 16.5353 11.2682 15.8474 12.3994 15.3779C13.5306 14.9084 14.7432 14.6665 15.968 14.666Z",
    fill: "#00A300"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 15.5,
    stroke: "#E9E9E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12012_27056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12012_27056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickBooksIcon);
export default __webpack_public_path__ + "static/media/QuickBooksIcon.6c7672f9bc62fb3bdc0299bb2ab87c8c.svg";
export { ForwardRef as ReactComponent };